/**
 * NOURION Kopfleiste: Nacht-zu-Tag-Wechsel, Vollbild-Mobilmenue mit
 * gestaffeltem Einflug, Fokusfalle ueber Kopfleiste + Menue und gezaehltem
 * Scroll-Lock. Die Anfrageliste ist seit 23.10.2026 entfallen (Anfragen und
 * Bestellungen laufen ueber store.nourion.de); ihren alten Speichereintrag
 * nourion-cart-v2 raeumt das Skript einmal aus dem Browser.
 *
 * Reinitialisiert sich bei shopify:section:load (Theme-Editor rendert Sections
 * ohne Seiten-Reload neu). Globale Listener (Scroll, Tastatur, Klick-
 * Delegation) werden dabei nur EINMAL registriert (Idempotenz-Guard ueber
 * window.__nourionHeaderBooted); DOM-Abfragen laufen bei jedem Aufruf frisch
 * ueber querySelector, damit neu gerendertes Markup automatisch mitspielt.
 */
(function () {
  'use strict';

  var SCROLL_THRESHOLD = 40;

  // Reste der frueheren Anfrageliste aus dem Browser entfernen
  try {
    window.localStorage.removeItem('nourion-cart-v2');
    window.sessionStorage.removeItem('nourion-anfrage');
  } catch (e) {
    /* Speicher blockiert: nichts zu tun */
  }

  // ── Gezaehlter Scroll-Lock, geteilt mit anderen Overlays ──
  if (!window.NourionScrollLock) {
    var lockCount = 0;
    window.NourionScrollLock = {
      acquire: function () {
        lockCount += 1;
        if (lockCount === 1) document.body.style.overflow = 'hidden';
      },
      release: function () {
        lockCount = Math.max(0, lockCount - 1);
        if (lockCount === 0) document.body.style.overflow = '';
      }
    };
  }

  // ── Nacht zu Tag: nur auf der Startseite scrollabhaengig, sonst immer Tag ──
  function syncDayNav() {
    var header = document.querySelector('[data-nourion-header]');
    if (!header) return;
    if (header.getAttribute('data-nourion-home') !== 'true') return;
    var crossed = window.scrollY > SCROLL_THRESHOLD;
    if (crossed) {
      header.classList.add('k-nav--day');
      header.classList.remove('dark-scope');
    } else {
      header.classList.remove('k-nav--day');
      header.classList.add('dark-scope');
    }
  }

  function onScroll() {
    syncDayNav();
  }

  // ── Vollbild-Mobilmenue ─────────────────────────────────────────────────
  function getMenu() { return document.querySelector('[data-nourion-mobile-menu]'); }
  function getToggle() { return document.querySelector('[data-nourion-menu-toggle]'); }

  function setToggleIcon(open) {
    var toggle = getToggle();
    if (!toggle) return;
    var menuIcon = toggle.querySelector('[data-nourion-icon-menu]');
    var closeIcon = toggle.querySelector('[data-nourion-icon-close]');
    if (menuIcon) menuIcon.hidden = open;
    if (closeIcon) closeIcon.hidden = !open;
    toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function isMenuOpen() {
    var menu = getMenu();
    return !!menu && menu.classList.contains('is-open');
  }

  function setBackgroundInert(active) {
    // Hintergrund fuer Screenreader und Tastatur stummschalten, solange das
    // Mobilmenue als Dialog offen ist (aria-modal braucht einen stummen Rest)
    var areas = [document.getElementById('MainContent'), document.getElementById('footer-group')];
    for (var i = 0; i < areas.length; i++) {
      var el = areas[i];
      if (!el) continue;
      if (active) el.setAttribute('inert', '');
      else el.removeAttribute('inert');
    }
  }

  function openMenu() {
    var menu = getMenu();
    if (!menu || menu.classList.contains('is-open')) return;
    menu.classList.add('is-open');
    setToggleIcon(true);
    window.NourionScrollLock.acquire();
    setBackgroundInert(true);
  }

  function closeMenu(returnFocus) {
    var menu = getMenu();
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    setToggleIcon(false);
    window.NourionScrollLock.release();
    setBackgroundInert(false);
    if (returnFocus) {
      var toggle = getToggle();
      if (toggle) toggle.focus();
    }
  }

  function toggleMenu() {
    if (isMenuOpen()) closeMenu(false);
    else openMenu();
  }

  function focusableElements(scope) {
    var nodes = scope.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el.hasAttribute('disabled') && el.offsetParent !== null) out.push(el);
    }
    return out;
  }

  function onKeydown(e) {
    if (!isMenuOpen()) return;
    if (e.key === 'Escape') {
      closeMenu(true);
      return;
    }
    if (e.key !== 'Tab') return;
    var header = document.querySelector('[data-nourion-header]');
    var menu = getMenu();
    var scopes = [];
    if (header) scopes.push(header);
    if (menu) scopes.push(menu);
    if (!scopes.length) return;

    var focusables = [];
    for (var i = 0; i < scopes.length; i++) {
      focusables = focusables.concat(focusableElements(scopes[i]));
    }
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = document.activeElement;
    var inside = false;
    for (var j = 0; j < scopes.length; j++) {
      if (scopes[j].contains(active)) { inside = true; break; }
    }

    if (e.shiftKey && (active === first || !inside)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !inside)) {
      e.preventDefault();
      first.focus();
    }
  }

  // ── Klick-Delegation (robust gegen shopify:section:load-Neurender) ────────
  function onDocumentClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var toggleBtn = target.closest('[data-nourion-menu-toggle]');
    if (toggleBtn) {
      toggleMenu();
    }
  }

  // ── Init / Reinit ──────────────────────────────────────────────────────
  function reinit() {
    syncDayNav();
    // Neu gerendertes Markup startet immer geschlossen, wie beim ersten Mount
    var menu = getMenu();
    if (menu) menu.classList.remove('is-open');
    setToggleIcon(false);
    setBackgroundInert(false);
  }

  function boot() {
    if (!window.__nourionHeaderBooted) {
      window.__nourionHeaderBooted = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      // Wechsel auf Desktop Breite bei offenem Mobilmenue: schliessen, sonst
      // blieben inert und Scroll Lock aktiv, waehrend Menue und Schliessknopf
      // per CSS unsichtbar sind (Seite waere unbedienbar, z. B. Tablet Drehung)
      var desktopQuery = window.matchMedia('(min-width: 1024px)');
      var onDesktopChange = function (e) { if (e.matches) closeMenu(false); };
      if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onDesktopChange);
      else if (desktopQuery.addListener) desktopQuery.addListener(onDesktopChange);
      window.addEventListener('keydown', onKeydown);
      document.addEventListener('click', onDocumentClick);
    }
    reinit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    reinit();
  });
})();
